import React from 'react';

type BadgeColor = 'blue' | 'orange' | 'purple' | 'green';

interface BadgeProps {
  children: React.ReactNode;
  color: BadgeColor;
  className?: string;
}

const Badge: React.FC<BadgeProps> = ({ children, color, className = '' }) => {
  const colorClasses = {
    blue: 'bg-blue-100 text-blue-800',
    orange: 'bg-orange-100 text-orange-800',
    purple: 'bg-purple-100 text-purple-800',
    green: 'bg-green-500 text-white',
  };

  return (
    <span className={`${colorClasses[color]} text-xs px-2 py-1 rounded ${className}`}>
      {children}
    </span>
  );
};

export default Badge;